import React, { useState, useEffect } from "react";
import ClientList from "./ClientList";
import { format } from "date-fns";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ConfirmDialog from "../components/ConfirmDialog";
import LoadingOverlay from "./LoadingOverlay";
import AddCustomerModal from "./AddCustomerModal";

const listTitle = ["Mr", "Ms"];

const inp =
  "w-full border border-gray-300 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-200 transition";
const inpDisabled =
  "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-100 text-gray-400 cursor-not-allowed";
const lbl =
  "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1";

const TABS = ["Header", "Item", "Pricing", "Terms"];

const NewQuotation = () => {
  const { user } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState(0);

  const [refNo, setRefNo] = useState("");
  const [quoteDesc, setQuoteDesc] = useState("");
  const [quotePn, setQuotePn] = useState("");
  const [quoteSize, setQuoteSize] = useState("");
  const [quoteMaterial, setQuoteMaterial] = useState("");
  const [quotePrinting, setQuotePrinting] = useState("");
  const [quotePrice1, setQuotePrice1] = useState("");
  const [quotePrice2, setQuotePrice2] = useState("");
  const [quotePrice3, setQuotePrice3] = useState("");
  const [quotePrice4, setQuotePrice4] = useState("");
  const [quotePrice5, setQuotePrice5] = useState("");
  const [quoteMpn, setQuoteMpn] = useState("");
  const [quoteCurrency, setQuoteCurrency] = useState("IDR");
  const [quoteLt, setQuoteLt] = useState("1 weeks");
  const [quoteCxl, setQuoteCxl] = useState("NCNR");
  const [quoteResch, setQuoteResch] = useState("NCNR");
  const [quoteDelTerm, setQuoteDelTerm] = useState("FOB BATAM");
  const [quotePayTerm, setQuotePayTerm] = useState("30 Days");
  const [quoteEffType, setQuoteEffType] = useState("PO BASED");
  const [quoteExpDate, setQuoteExpDate] = useState(
    "3 months after the date of quotation",
  );
  const [quoteOrigin, setQuoteOrigin] = useState("Indonesia");
  const [attn, setAttn] = useState("");
  const [title, setTitle] = useState("0");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [clientRefreshKey, setClientRefreshKey] = useState(0);
  const [inputDateSelected, setInputDateSelected] = useState(new Date());
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    fetchQuotationId();
  }, []);

  const fetchQuotationId = async () => {
    try {
      const res = await axios.get(
        `https://eps.elkomprintama.com/get/api/quotation`,
      );
      setRefNo(res.data.result[0].max_quote_id + 1);
    } catch (e) {
      console.error("Error fetching quotation id:", e);
    }
  };

  const insertQuotation = async () => {
    setIsLoading(true);
    try {
      await axios.post(`https://eps.elkomprintama.com/post/api/quotation`, {
        quote_id: refNo,
        quote_date: format(inputDateSelected, "yyyy-MM-dd"),
        cust_id: selectedClientId,
        attn: title + " " + attn,
        descr: quoteDesc,
        pn: quotePn,
        size: quoteSize,
        mat: quoteMaterial,
        clr: quotePrinting,
        price1: quotePrice1,
        price2: quotePrice2,
        price3: quotePrice3,
        price4: quotePrice4,
        price5: quotePrice5,
        curr: quoteCurrency,
        lead: quoteLt,
        term: quotePayTerm,
        effect_type: quoteEffType,
        mpn: quoteMpn,
        coo: quoteOrigin,
        admin: user.username,
      });
      toast.success("Quotation created successfully.");
      fetchQuotationId();
      setTitle("0");
      setAttn("");
      setQuoteDesc("");
      setQuotePn("");
      setQuoteSize("");
      setQuoteMaterial("");
      setQuotePrinting("");
      setQuotePrice1("");
      setQuotePrice2("");
      setQuotePrice3("");
      setQuotePrice4("");
      setQuotePrice5("");
      setActiveTab(0);
    } catch (e) {
      toast.error("Failed to create quotation. Please try again.");
    } finally {
      setIsLoading(false);
      setUploadPending(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      title === "0" ||
      !attn ||
      !quoteDesc ||
      !quotePn ||
      !quoteSize ||
      !quoteMaterial ||
      !quotePrinting ||
      !quotePrice1
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <>
      <div className="w-full rounded-lg bg-blue-600 mb-4">
        <label className="block uppercase text-white mb-2 tracking-wide text-5xl text-center font-bold">
          New Quotation
        </label>
      </div>

      <div className="bg-white shadow-md rounded-xl border border-gray-200 flex flex-col">
        {/* Tab bar */}
        <div className="flex border-b border-gray-200 px-4 pt-3 gap-1">
          {TABS.map((tab, i) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2 text-sm font-semibold rounded-t-lg transition focus:outline-none ${
                activeTab === i
                  ? "bg-blue-600 text-white"
                  : "text-gray-500 hover:text-blue-600 hover:bg-blue-50"
              }`}
            >
              {i + 1}. {tab}
            </button>
          ))}
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col">
          <div className="px-6 py-5">
            {/* Tab 1: Header */}
            {activeTab === 0 && (
              <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={lbl}>Quotation Number</label>
                    <input
                      className={inpDisabled}
                      value={refNo}
                      disabled
                      readOnly
                    />
                  </div>
                  <div>
                    <label className={lbl}>Date</label>
                    <DatePicker
                      className={inp}
                      wrapperClassName="w-full"
                      selected={inputDateSelected}
                      onChange={setInputDateSelected}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
                <div>
                  <label className={lbl}>
                    Customer <span className="text-red-400">*</span>
                  </label>
                  <div className="flex gap-2 items-center">
                    <div className="flex-1">
                      <ClientList
                        onChangeList={setSelectedClientId}
                        onInitial={setSelectedClientId}
                        showLabel={false}
                        refreshKey={clientRefreshKey}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowAddCustomer(true)}
                      className="flex-shrink-0 h-9 w-9 flex items-center justify-center rounded-lg border border-gray-300 bg-white hover:bg-indigo-50 hover:border-indigo-400 text-gray-500 hover:text-indigo-600 text-xl font-bold transition"
                      title="Add new customer"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-4 gap-4">
                  <div>
                    <label className={lbl}>
                      Title <span className="text-red-400">*</span>
                    </label>
                    <select
                      className={inp}
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    >
                      <option value="0">Select</option>
                      {listTitle.map((t) => (
                        <option key={t} value={t}>
                          {t}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-span-3">
                    <label className={lbl}>
                      Attention <span className="text-red-400">*</span>
                    </label>
                    <input
                      className={inp}
                      name="attn" type="text"
                      placeholder="Contact name"
                      value={attn}
                      onChange={(e) => setAttn(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Tab 2: Item */}
            {activeTab === 1 && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={lbl}>
                    Description <span className="text-red-400">*</span>
                  </label>
                  <input
                    className={inp}
                    name="quotedesc" type="text"
                    placeholder="Description"
                    value={quoteDesc}
                    onChange={(e) => setQuoteDesc(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>
                    Part Number <span className="text-red-400">*</span>
                  </label>
                  <input
                    className={inp}
                    name="quotepn" type="text"
                    placeholder="Part number"
                    value={quotePn}
                    onChange={(e) => setQuotePn(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>
                    Size <span className="text-red-400">*</span>
                  </label>
                  <input
                    className={inp}
                    name="quotesize" type="text"
                    placeholder="Size"
                    value={quoteSize}
                    onChange={(e) => setQuoteSize(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>
                    Material <span className="text-red-400">*</span>
                  </label>
                  <input
                    className={inp}
                    name="quotematerial" type="text"
                    placeholder="Material"
                    value={quoteMaterial}
                    onChange={(e) => setQuoteMaterial(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>
                    Printing / Colour <span className="text-red-400">*</span>
                  </label>
                  <input
                    className={inp}
                    name="quoteprinting" type="text"
                    placeholder="Printing / colour"
                    value={quotePrinting}
                    onChange={(e) => setQuotePrinting(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Tab 3: Pricing */}
            {activeTab === 2 && (
              <div>
                <p className="text-xs text-gray-400 mb-3">
                  Double-click a label to fill with the default price template.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    {
                      label: "Pricing 1",
                      val: quotePrice1,
                      set: setQuotePrice1,
                      required: true,
                    },
                    {
                      label: "Pricing 2",
                      val: quotePrice2,
                      set: setQuotePrice2,
                    },
                    {
                      label: "Pricing 3",
                      val: quotePrice3,
                      set: setQuotePrice3,
                    },
                    {
                      label: "Pricing 4",
                      val: quotePrice4,
                      set: setQuotePrice4,
                    },
                    {
                      label: "Pricing 5",
                      val: quotePrice5,
                      set: setQuotePrice5,
                    },
                  ].map(({ label, val, set, required }) => (
                    <div key={label}>
                      <label
                        className={`${lbl} cursor-pointer select-none`}
                        onDoubleClick={() => set("QTY.................@Rp")}
                        title="Double-click to fill template"
                      >
                        {label}{" "}
                        {required && <span className="text-red-400">*</span>}
                      </label>
                      <input
                        className={inp}
                        name="val" type="text"
                        placeholder={label}
                        value={val}
                        onChange={(e) => set(e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Tab 4: Terms */}
            {activeTab === 3 && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className={lbl}>Currency</label>
                  <input
                    className={inp}
                    name="quotecurrency" type="text"
                    placeholder="e.g. IDR"
                    value={quoteCurrency}
                    onChange={(e) => setQuoteCurrency(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>MPN (Optional)</label>
                  <input
                    className={inp}
                    name="quotempn" type="text"
                    placeholder="MPN"
                    value={quoteMpn}
                    onChange={(e) => setQuoteMpn(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Lead Time</label>
                  <input
                    className={inp}
                    name="quotelt" type="text"
                    placeholder="e.g. 1 weeks"
                    value={quoteLt}
                    onChange={(e) => setQuoteLt(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Cxl</label>
                  <input
                    className={inp}
                    name="quotecxl" type="text"
                    placeholder="e.g. NCNR"
                    value={quoteCxl}
                    onChange={(e) => setQuoteCxl(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Reschedule</label>
                  <input
                    className={inp}
                    name="quoteresch" type="text"
                    placeholder="e.g. NCNR"
                    value={quoteResch}
                    onChange={(e) => setQuoteResch(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Delivery Terms</label>
                  <input
                    className={inp}
                    name="quotedelterm" type="text"
                    placeholder="e.g. FOB BATAM"
                    value={quoteDelTerm}
                    onChange={(e) => setQuoteDelTerm(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Payment Terms</label>
                  <input
                    className={inp}
                    name="quotepayterm" type="text"
                    placeholder="e.g. 30 Days"
                    value={quotePayTerm}
                    onChange={(e) => setQuotePayTerm(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Effective Type</label>
                  <input
                    className={inp}
                    name="quoteefftype" type="text"
                    placeholder="e.g. PO BASED"
                    value={quoteEffType}
                    onChange={(e) => setQuoteEffType(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Expiration Date</label>
                  <input
                    className={inp}
                    name="quoteexpdate" type="text"
                    placeholder="e.g. 3 months after..."
                    value={quoteExpDate}
                    onChange={(e) => setQuoteExpDate(e.target.value)}
                  />
                </div>
                <div>
                  <label className={lbl}>Country of Origin</label>
                  <input
                    className={inp}
                    name="quoteorigin" type="text"
                    placeholder="e.g. Indonesia"
                    value={quoteOrigin}
                    onChange={(e) => setQuoteOrigin(e.target.value)}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Footer: nav + submit always visible */}
          <div className="border-t border-gray-200 px-6 py-3 bg-gray-50 rounded-b-xl flex items-center justify-between">
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setActiveTab((t) => Math.max(0, t - 1))}
                disabled={activeTab === 0}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition"
              >
                ← Prev
              </button>
              <button
                type="button"
                onClick={() =>
                  setActiveTab((t) => Math.min(TABS.length - 1, t + 1))
                }
                disabled={activeTab === TABS.length - 1}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-600 bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition"
              >
                Next →
              </button>
            </div>
            {activeTab === TABS.length - 1 && (
              <button
                type="submit"
                className="px-8 py-2 rounded-lg text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 transition"
              >
                Create Quotation
              </button>
            )}
          </div>
        </form>
      </div>

      {isLoading && <LoadingOverlay message="Creating quotation..." />}
      {showConfirm && uploadPending && (
        <ConfirmDialog
          message="Are you sure you want to create this quotation?"
          onConfirm={() => {
            setShowConfirm(false);
            insertQuotation();
          }}
          onCancel={() => {
            setShowConfirm(false);
            setUploadPending(false);
          }}
        />
      )}
      {showAddCustomer && (
        <AddCustomerModal
          onClose={() => setShowAddCustomer(false)}
          onAdded={() => setClientRefreshKey((k) => k + 1)}
        />
      )}
    </>
  );
};

export default NewQuotation;
